import { Add } from "@dreamhub/designsystem/icons";
import { Button, ButtonProps } from "@/components/ui/button";
import IconContainer from "@/components/ui/icon-container";
import { TextVariant } from "@/components/ui/text";
import { cn } from "@/utils/utils";
import React, { ReactNode } from "react";
import Text from "@/components/ui/text";

export interface AddActionButtonProps extends ButtonProps {
  label: string;
  onClick: () => void;
  className?: string;
  leftIcon?: ReactNode;
  textVariant?: TextVariant;
  hideIcon?: boolean;
  "data-test"?: string;
}

const AddActionButton: React.FC<AddActionButtonProps> = ({
  label,
  onClick,
  className = "",
  leftIcon,
  textVariant = "body",
  hideIcon = false,
  "data-test": dataTest,
  ...props
}) => {
  return (
    <Button
      variant="tertiary"
      onClick={onClick}
      className={cn(className)}
      type={props?.type}
      data-test={dataTest}
    >
      {!hideIcon && (
        <IconContainer size="5" color="cta" className="[&>svg]:size-4">
          {leftIcon ? leftIcon : <Add />}
        </IconContainer>
      )}
      <Text variant={textVariant} className="text-cta">
        {label}
      </Text>
    </Button>
  );
};

export default AddActionButton;
